import urlHelper from '../Helpers/urlHelper';

export default class PrePaymentPaymentItem {
  constructor(item) {
    if (item) {
      this.ClientPaymentId = item.clientPaymentId;
      this.PaymentDate = item.paymentDate;
      this.Paid = item.paid;
      this.CheckNumber = item.checkNumber;
      this.LineItemPaymentId = item.lineItemPaymentId;
      this.CurrencyCode = item.currencyCode;
      return;
    }
    this.ClientPaymentId = '';
    this.PaymentDate = '';
    this.Paid = '';
    this.CheckNumber = '';
    this.LineItemPaymentId = '';
    this.CurrencyCode = '';
  }

  static MoneyFields = ['Paid'];
  static MoneyFieldsSecondary = ['Paid'];

  static Currency() {
    return 'CurrencyCode';
  }

  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static DateFields = ['PaymentDate'];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Client Payment ID',
        orderById: 'ClientPaymentId',
        data: PrePaymentPaymentItem.GetDetailCellContent,
        minWidth: 20
      },
      { label: 'Payment Date', orderById: 'PaymentDate', data: 'PaymentDate', minWidth: 40 },
      {
        label: 'Paid',
        orderById: 'Paid',
        data: 'Paid',
        minWidth: 20
      },
      {
        label: 'Check Number',
        orderById: 'CheckNumber',
        data: 'CheckNumber',
        minWidth: 40
      },
      {
        label: 'Transaction ID',
        orderById: 'LineItemPaymentId',
        data: 'LineItemPaymentId',
        minWidth: 40
      }
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ClientPaymentId,
      '',
      '',
      'clientpaymentdetails',
      `id=${item.ClientPaymentId}`,
      'Open up in a new tab'
    );
  }
}
